import { Outlet } from "react-router-dom";

const MainIssued = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainIssued;